import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GetPartnerBySubdomain, MediaIdentifier, Partner, PartnerButton, PartnerState, TextSectionIdentifier } from '@fitscovery/partner/data-access';
import { Select, Store } from '@ngxs/store';
import { UtilCustomButtonAlignment } from 'libs/partner-web/partner-homepage/src/lib/shared/util';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { UtilSubdomain } from '@fitscovery/partner-web/shared/utils';

@Component({
  selector: 'fitscovery-ui-default-banner',
  templateUrl: './ui-default-banner.component.html',
  styleUrls: ['./ui-default-banner.component.scss'],
})
export class UiDefaultBannerComponent implements OnInit {

  @Select(PartnerState.partner) partner$: Observable<Partner>;

  @Input() partner: Partner;
  partnerButton: PartnerButton | null;

  constructor(
    private router: Router,
    private store: Store,
    private subdomain: UtilSubdomain,
  ) { }

  async ngOnInit() {

    this.partner$.pipe(
      filter(Boolean),
      take(1)
    ).subscribe((partner: Partner) => {
        this.partner = partner;
        this.partnerButton = null;
    });

    const subdomain = this.subdomain.getSubdomain();
    const partner = (await this.store.dispatch(new GetPartnerBySubdomain(subdomain)).toPromise()).partner.data as Partner;
    this.partner = partner;
    this.partnerButton = partner?.imageDescriptions!?.find((section: any) => {
      return section?.identifier === MediaIdentifier.BannerImage;
    })!.buttons![0];

  }

  getHeader(): string {
    const header = this.partner?.textSections!.find((section) => {
      return section?.identifier === TextSectionIdentifier.Header;
    });
    return (header && header?.text ? header?.text : this.partner?.name) || '';
  }

  getSubHeader(): string {
    const header = this.partner?.textSections!.find((section) => {
      return section.identifier === TextSectionIdentifier.Description;
    });
    return (header && header?.text) || '';
  }

  getImageDescription(): PartnerButton {
    const bannerImage = this.partner?.imageDescriptions?.find((section) => {
      return section?.identifier === MediaIdentifier.BannerImage;
    });
    return bannerImage?.buttons![0]!;
  }

  goToSchedule(): void {
    this.router.navigate(['/events/list']);
  }

  contactMe(): void {
    const email =
      this.partner && this.partner?.contactInfo
        ? `mailto:${this.partner?.contactInfo.email}`
        : null;
    //TODO: [AA] Call url service to redirect to email url
  }

  setButtonAlignmentClass(button: PartnerButton): string {
    return UtilCustomButtonAlignment.setButtonAlignment(button)!;
  }
}
